"use client"

import { useEffect, useState } from "react"
import { X, AlertTriangle } from "lucide-react"

interface RightClickModalProps {
  isAdmin?: boolean
}

export function RightClickModal({ isAdmin = false }: RightClickModalProps) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isAdmin) return

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault()
      setIsOpen(true)
    }

    document.addEventListener("contextmenu", handleContextMenu)
    return () => document.removeEventListener("contextmenu", handleContextMenu)
  }, [isAdmin])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={() => setIsOpen(false)}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="right-click-dialog-title"
        className="relative w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-xl dark:border-indigo-950 dark:bg-stone-950"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setIsOpen(false)}
          className="absolute right-4 top-4 rounded-full p-1 text-slate-500 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-50"
        >
          <X className="h-5 w-5" />
          <span className="sr-only">Close</span>
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="mb-4 rounded-full bg-amber-100 p-3 dark:bg-amber-900/30">
            <AlertTriangle className="h-6 w-6 text-amber-600 dark:text-amber-500" />
          </div>

          <h3 id="right-click-dialog-title" className="mb-2 text-lg font-semibold text-slate-900 dark:text-slate-50">
            Right Click is Not Supported
          </h3>

          <p className="text-sm text-slate-500 dark:text-slate-400">
            These photos are copyright protected. A low resolution digital download for social media use is available for free.
          </p>

          <button
            onClick={() => setIsOpen(false)}
            className="mt-6 w-full rounded-md bg-stone-950 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-200"
          >
            Understood
          </button>
        </div>
      </div>
    </div>
  )
}
